<!--  -->
<template>
  <div class="springFestival" v-show="adData.id">
    <img :src="adData.images" @click="jumpCourseDetail" alt="" />
  </div>
</template>

<script>
import { setBaseUrl,handleJumpType } from '@/utils/tools';

import { reqAdvertPlaying } from '@/api/home/index';

export default {
  components: {},
  data() {
    return {
      adData: {},
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getAdvert() {
      const res = await reqAdvertPlaying(['ykc0001']);
      if (res.code === 0 && res?.data) {
        this.adData = res?.data?.find((item) => item.adCode === 'ykc0001')
          ?.advertisingContentWebInfoRespVOS?.[0] || {};
      }
    },
    goback() {
      sessionStorage.setItem('back', true);
    },

    jumpCourseDetail() {
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      handleJumpType(this, this.adData);
    },
  },
  created() {
    this.getAdvert();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.springFestival {
  margin-bottom: 16px;
  img {
    width: 750px;
    height: 83px;
  }
}
</style>
